<template>
  <div ref="trendLine" class="trend-line-report-section">
    <h5 class="data-title text-center">
      <span class="selected-data-type" @click.stop="toggleOpen">
        <group-names
            v-if="hasFilters"
            :groups="onlySelectedGroups"
            hideGroupName
            isOnlySelected>
        </group-names>
        <template v-if="!hasFilters">all</template>
      </span>
      customers
    </h5>

    <groups-drop-down
        v-show="groupsWithSelected"
        :groupsWithSelected="groupsWithSelected"
        :isUpdating="updating"
        :openGroupItem="openGroupItem"
        :sectionOpen="sectionOpen"
        :slideDown="slideDown"
        @closeDropDown="closeDropDown"
        @closeSelectedGroup="closeSection"
        @setSelected="delayedSetSelectedGroups"
        @setSelectedItem="setSelectedItem">
    </groups-drop-down>

    <select-by-type
        :customSelected="metric"
        textBeforeSelected=""
        textAfterSelected="by time"
        @setDataType="setReportDataType">
    </select-by-type>

    <div v-if="errorText" v-html="errorText" class="error-label text-center">{{errorText}}</div>

    <line-graph
        v-if="graphData && wrapperWidth && !errorText"
        :graphData="graphData"
        :toolTipContent="toolTipContent"
        :wrapperWidth="wrapperWidth"
        xSelector="date_time"
        ySelector="amount"
        @setToolTipContent="setToolTipContent">
    </line-graph>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import GroupsDropDown from '../GroupWidget/GroupsDropDown'
  import GroupNames from '../GroupWidget/GroupNames'
  import LineGraph from '../Graphs/LineGraph'
  import OnlySelectedGroups from '../../mixins/OnlySelectedGroupsMixin'
  import ReportsMixin from '../../mixins/ReportsMixin'
  import SelectByType from './SelectByType'
  import ToolTipContentMixin from '../../mixins/ToolTipContentMixin'

  export default {
    props: {
      error: String,
      graphData: Array,
      isTracked: Boolean,
      updating: Boolean,
      wrapperWidth: [Number, String],
    },

    name: 'TrendLineReport',

    components: {
      GroupsDropDown,
      GroupNames,
      LineGraph,
      SelectByType,
    },

    mixins: [AxiosMixin, OnlySelectedGroups, ReportsMixin, ToolTipContentMixin],

    data() {
      return {
        baseErrorMessage: 'could not load selected filters',
        delayedUpdate: {},
        errorMessage: null,
        graphParams: null,
        groupsWithSelected: null,
        openGroupItem: null,
        sectionOpen: false,
        selectedGroups: {},
        slideDown: false,
        toolTipContent: null,
        urlParams: null,
      }
    },

    methods: {
      buildGroupIdsParams(params) {
        if (this.segmentIds.length) { params.params.segment_ids = this.segmentIds }
        if (this.tagIds.length) { params.params.merchant_tag_ids = this.tagIds }
        return params
      },

      buildUrlParams() {
        let params = { params: { metric: this.metric } }
        if (this.hasFilters) { this.buildGroupIdsParams(params) }
        this.graphParams = params
      },

      buildSelectedGroupsArray(buildTags) {
        const tagContexts = ['brand', 'category', 'discount', 'interest', 'location']
        let selectedItems = []
        for (let key in this.selectedGroups) {
          let isTag = tagContexts.includes(key)
          let mergedArray = selectedItems.concat(...this.selectedGroups[key])
          if (buildTags && isTag) { selectedItems = mergedArray }
          if (!buildTags && !isTag) { selectedItems = mergedArray }
        }
        return selectedItems
      },

      clearDelayedSet(groupId) {
        const id = this.delayedUpdate.groupId
        if (id && id === groupId) { clearTimeout(this.delayedUpdate.timeout) }
      },

      closeDropDown() {
        this.slideDown = false
        this.closeSection()
      },

      closeSection() {
        this.sectionOpen = false
        this.openGroupItem = null
      },

      delayedSetSelectedGroups(groupId, selectedGroups) {
        this.clearDelayedSet(groupId)
        this.delayedUpdate.groupId = groupId
        this.delayedUpdate.timeout = setTimeout(() => this.setSelectedGroups(groupId, selectedGroups), 500)
      },

      loadGraphData() {
        this.buildUrlParams()
        this.$emit('loadGraphData', 'trendline', 'trends', this.graphParams)
      },

      loadSelectedGroups() {
        let url = `/api/v3/groups/`,
          params = {
            params: {
              merchant_segment_ids: this.segmentIds,
              merchant_tag_ids: this.tagIds
            }
          }
        this.axiosMethod({url, params, onSuccess: this.onSuccessLoadGroups, onError: this.onErrorLoadGroups})
      },

      onSuccessLoadGroups(data) {
        const isValidData = Array.isArray(data)
        if (isValidData) { this.groupsWithSelected = data }
        this.errorMessage = isValidData ? '' : this.baseErrorMessage
      },

      onErrorLoadGroups(error) {
        this.errorMessage = `${this.baseErrorMessage}: ${error}`
      },

      setReportDataType(dataType) {
        if (this.reportDataType !== dataType) {
          this.reportDataType = dataType
          this.loadGraphData()
        }
      },

      setSelectedItem(item) {
        this.openGroupItem = item
        this.sectionOpen = true
      },

      setSelectedGroups(groupId, selectedGroups) {
        this.$set(this.selectedGroups, groupId, selectedGroups)
        this.loadGraphData()
        this.loadSelectedGroups()
      },

      setToolTipContent(item) {
        this.toolTipContent = this.getToolTipContent(item, 'trends')
      },

      toggleOpen() {
        this.slideDown = !this.slideDown
        if (!this.slideDown) { this.closeSection() }
      },
    },

    created() {
      this.loadGraphData()
      this.loadSelectedGroups()
    },

    computed: {
      errorText: function() {
        const hasMulti = !!this.error && !!this.errorMessage
        return hasMulti ? `${this.error} <br /> ${this.errorMessage}` : this.error ? this.error : this.errorMessage
      },

      hasFilters: function() {
        return this.segmentIds.length ||  this.tagIds.length
      },

      segmentIds: function() {
        return this.buildSelectedGroupsArray()
      },

      tagIds: function() {
        return this.buildSelectedGroupsArray(true)
      },
    },
  }
</script>